export const locale = {
  lang: 'en',
  data: {
    'AVANCES': {
      'GOSURVEY':'Go to survey',
      'GOPORTAL':'Go to counting portal',
      'REGRESAR':'Back',
      'DESCARGAR':'Download excel',
      'PRIMEROS':'Get firts 1000 rows',
      'SINCRONIZAR':'Synchronize with counting portal',
      'AGREGAR': 'Add',
      'PRODUCTO':'Product',
      'FEC-LAN': 'Launch date',
      'FEC-CIE': 'Closing date',
      'NOFEC-LAN': "You haven't scheduled a launch date yet",
      'FEC-CIE-PROR': 'Closing date extended',
      'CER': 'Close Survey',
      'ABR': 'Open Survey',
      'SURVEY':'Survey: ',
      'FILE':'Cultura Go Cloud Drive: ',
      'PROR':'EXTEND SURVEY',
      'WARNING-FECHA-GUARDAR':'Are you sure to add dated extensions ',
      'SUCCESS-PRORROGA': 'The closing date has been changed to ',
      'WARNING-CIERRE-ENCUESTA':'Are you sure to change the status of the survey',
      'SUCCESS-CIERRE': 'The survey was changed correctly',
      'PORCENTAJE':'Preview of responses: ',
      'DES':'Click to show    ',
      'WARNING-BTN':'This action can not be completed as your survey has not been launched',
      'PROCESARRESU': 'Process results',
      'ETIQUETAS':{
        'ETIQUETAS': 'Items per page',
        'OF': 'of',
      },
      'BOTONES-MODALES':{
        'ELIMINAR':{
          'MESSAGE1':'<span>To confirm the removal of user answers',
          'MESSAGE2':', enter the user name in the text box</span>',
          'MESSAGE3':'<span>To confirm the removal of user answers, enter the next user name in the text box ',
          'SALIR': 'Exit',
          'VALIDAR': 'Confirm user',
          'ERRORNOMBREEMPRESA': 'The name of the user entered, does not match the name of the user you want to delete',
          'MENSAJE': '¿Are you sure?\n\nYou are about to delete user answers ',
          'CANCELAR': 'Cancel',
          'CONFIRMAR': 'Yes, delete',
          'SUCCES': 'The answers were delete',
          'CERRAR': 'Close'
        },
        'MESSAGE':'¿Are you sure you want delete the answers of user ',
        'RESP_SI':'Yes',
        'RESP_NO':'No',
        'ACEPTAR':' Accept',
        'CANCELAR':'Cancel',
        'OK':'Ok',
        'SUCCESS-DELETE':'Answers deleted successfully',
        'ERROR-DELETE':'Something wrong happened',
      },
      'PROCESAR': {
        'OK': 'The process started successfully',
        'NOTOK': 'The process could not start, first you need to set the desired results'
      },
      'INS':{
        'INS1':' of ',
        'INS2':' collaborators '
      },
      'INICIO':{
        'TITULO':'Survey status by user',
        'INSTRUCCIONES':'On the left side there is a bar with the products purchased by the company. Clicking on one of them shows the customers by years, please select one to be able to show the list of users who are conducting the survey of said product.',
      },
      'ENCUESTA':{
        'TTITULO': 'Progress survey by user',
        'PRODUCTS':'Owned products',
        'LABEL01':'Name',
        'LABEL02':'Email',
        'LABEL03':'Survey key',
        'LABEL04':'Status',
        'LABEL05':'Invitation',
        'LABEL06':'Reminder',
        'LABEL07':'Delete',
        'LABEL08':'Start',
        'LABEL09':'End',
        'LABEL10':'User actions',
        'LABEL11':'Survey actions',
        'LABEL12':'Access key',
        'DESCARGAR':'Downloading, please wait...',
        'BUSCAR':'Search',
        'TITULOEXCEL':'Survey status',
        'CARGANDO':'Loading',
        'ACTIVA':'Survey not enable',
        //, please wait... Your total collaborators:
        'PLACE':'Write the name of the collaborator you want looking for',
        'ACTIONS':'Special actions',
        'NOUSER':'Search not found',
        'NA':'Not available',
        'ERROR':'This product does not have an survey yet',
        'SUCCESS1':'Invitation sent',
        'SUCCESS2':'Reminder sent',
        'ERROR1':'Something wrong happened',
      },
      'TITULOS':{
        'NAME':'Collaborator name',
        'ESTADOS':'Survey status',
        'FECHA1':'Survey begin',
        'FECHA2':'End survey',
        'ESTADOS_ENC':{
          'TITULO':'Select an option',
          'TODO':'Show all',
          'ESTADO1':'Not started the survey',
          'ESTADO2':'The user has been loged in',
          'ESTADO3':'Survey on progress',
          'ESTADO4':'Survey finished ',
          'ESTADO5':'Not Accepted',
          'ESTADO6':'I accept the survey',
        }
      },
      'COLUMNAS':{
        'email':'Email',
        'end_date':'End date',
        'id_status':'Status',
        'name':'Name',
        'start_date':'Begin date'
      },
      'ACCIONES_EMAIL':{
        'ACCIONES':'Actions on survey',
        'INFO':'The next steps show you the actions aviable for user ',
        'ACC1':'Send invitation',
        'ACC2':'Send reminder',
        'ACC3':'Delete survey answer',
      },
      'NEWCOLAB': {
        'TITULO': 'Add new participant to the survey',
        'INST_1': 'Complete each of the required data sets to add a new participant',
        'TITULO_MOD': 'Modify collaborator data',
        'INST_1_MOD': 'You can make modifications to each of the data sets of the selected collaborator',
        'INST_2': 'The fields marked with (*) are required',
        'WARNING1':'NOTE: THE KEY OF THIS COLLABORATOR ',
        'WARNING2':' CANNOT BE MODIFIED',
        'DATASET_1': 'Dataset 1',
        'DATASET_2': 'Dataset 2',
        'DATASET_3': 'Dataset 3',
        'DATASET_4': 'Dataset 4',
        'DATASET_5': 'Dataset 5',
        'DATASET_6': 'Dataset 6',
        'DATASET_7': 'Dataset 7',
        'REQUIRED': 'This field is required',
        'NEXT': 'Next',
        'BACK': 'Previous',
        'SAVE': 'Save',
        'ERR_OWNKEY': 'The employee number entered is already stored in the database, try a different one',
        'ERR_BOSSKEY': 'The boss number entered is not stored in the database, try a different one',
        'ERR_VAL_1': 'The data entered in the field: ',
        'ERR_VAL_2': '  contains illegal characters, or is not in the correct format',
        'GUARDANDO': 'Participant information is being stored, please wait',
        'GUARDANDO_GOFLOW': 'The information is being stored, please wait.',
        'SAVE_OK': 'The information of the new participant has been stored correctly',
        'MOD_OK': 'Participant information has been successfully modified',
        'FORMULARIO': 'You have not yet completed the registration form, check that you have filled all the required fields and try again',
        'ACCIONES': 'Actions',
        'VERACT': 'User actions',
        'LOADACT': 'Loading available actions',
        'NOACT': 'No additional actions can be performed for this contributor',
        'AVAACT': 'The following actions can be performed for  collaborator',
        'ACCIONLIST': {
          'modificar': 'Modify the information of the selected collaborator',
          'borrar': 'Delete the selected collaborator'
        },
        'DELCOLAB': 'Do you confirm to remove the selected collaborator from this product? Note: This action cannot be reversed',
        'DEL_OK': 'This collaborator was successfully removed from the product',
        'ERR_EMAIL': 'The email address entered is already stored in the database, try a different one',
        'ERR_SAMEKEY': 'The entered boss key and the collaborator key are the same, this is not allowed, try a different one',
        'RESET_COLAB_SURVE': 'Do you confirm to reset the access to the survey? ',
        'ACTU_OK': 'It was updated correctly',
      },
      'FORMULARIO_GO_FLOW':{
        'perspective': 'Perspective',
        'statementID': 'Reactive ID',
        'dimensionL1': 'Dimension L1',
        'dimensionL2': 'Dimension L2',
        'survey_Score_OverallTI': 'GlobalTI Score Survey',
        'company_Country': 'Country Company',
        'cgo_Product_Name': 'Product name cgo',
        'company_Name': 'Company name',
        'ranking_Year': 'Ranking year',
        'survey_Respondents': 'Respondents',
        'survey_Score_Camaraderie': 'Camaraderie Score Survey',
        'survey_Score_Credibility': 'Credibility Score Survey',
        'survey_Score_Imparciality': 'Impartiality Score Survey',
        'survey_Score_Pride': 'Pride Score Survey',
        'survey_Score_Respect': 'Respect Score Survey',
        'survey_Score_Gestalt': 'Gestalt Score Survey',
        'pdf_DateCreation': 'Certificate creation date',
        'WARNI_TI_DA':'The value entered does not correspond to the allowed format (100.00)',
        'WARNI_TI_DA_GRAL':'The data entered is not in the format specified',
        'numUsers': 'Collaborators'
      },
      'FORMULARIO':{
        'fullName': 'FULL NAME',
        'ownKey': 'EMPLOYEE NUMBER',
        'age': 'YEAR OF BIRTH',
        'surveyKey': 'SURVEY ACCESS KEY',
        'email': 'EMAIL',
        'bossName': 'DIRECT BOSS NAME',
        'bossKey': 'DIRECT BOSS NUMBER',
        'country': 'COUNTRY',
        'location': 'LOCATION',
        'geo_1': 'GEOGRAPHIC LEVEL 1',
        'geo_2': 'GEOGRAPHIC LEVEL 2',
        'geo_3': 'GEOGRAPHIC LEVEL 3',
        'geo_4': 'GEOGRAPHIC LEVEL 4',
        'geo_5': 'GEOGRAPHIC LEVEL 5',
        'geo_6': 'GEOGRAPHIC LEVEL 6',
        'geo_7': 'GEOGRAPHIC LEVEL 7',
        'geo_8': 'GEOGRAPHIC LEVEL 8',
        'geo_9': 'GEOGRAPHIC LEVEL 9',
        'geo_10': 'GEOGRAPHIC LEVEL 10',
        'geo_19': 'GEOGRAPHIC LEVEL 19',
        'structure_1': 'STRUCTURAL LEVEL 1',
        'structure_2': 'STRUCTURAL LEVEL 2',
        'structure_3': 'STRUCTURAL LEVEL 3',
        'structure_4': 'STRUCTURAL LEVEL 4',
        'structure_5': 'STRUCTURAL LEVEL 5',
        'structure_6': 'STRUCTURAL LEVEL 6',
        'structure_7': 'STRUCTURAL LEVEL 7',
        'structure_8': 'STRUCTURAL LEVEL 8',
        'structure_9': 'STRUCTURAL LEVEL 9',
        'structure_10': 'STRUCTURAL LEVEL 10',
        'area': 'AREA',
        'bUnit': 'BUSINESS UNIT',
        'enterDate': 'DATE OF ENTRY TO THE COMPANY',
        'antiquity': 'ANTIQUITY',
        'antiquityUS': 'ANTIQUITY US',
        'generation': 'GENERATION',
        'generationUS': 'GENERATION US',
        'ageUS': 'AGE',
        'charge': 'POSITION OR FUNCTION IN THE COMPANY',
        'homologado': 'CHARGE OR FUNCTION APPROVED',
        'homologadoUS': 'CHARGE OR FUNCTION APPROVED US',
        'gender': 'GENDER',
        'genderType': 'TYPE OF GENDER',
        'typeofwork': 'TYPE OF COMPENSATION',
        'workCondition': 'WORKING CONDITION',
        'academico': 'ACADEMIC DEGREE',
        'contratacion': 'CONTRACT TYPE',
        'situacionUS': 'WORK SITUATION US',
        'personal': 'EMPLOYEE TYPE',
        'jornada': 'TYPE OF WORK SCHEDULE',
        'rotacion': 'DOES SHIFT ROTATION',
        'phone': 'COLLABORATOR\'S PHONE',
        'extension': 'DIRECT EXTENSION OF THE COLLABORATOR',
        'cellphone': 'COLLABORATOR\'S CELLPHONE',
        'native': 'NATIVE LANGUAGE',
        'answer': 'ANSWER',
        'other_1': 'OTHERS 1',
        'other_2': 'OTHERS 2',
        'other_3': 'OTHERS 3',
        'other_4': 'OTHERS 4',
        'other_5': 'OTHERS 5',
        'other_6': 'OTHERS 6',
        'other_7': 'OTHERS 7',
        'other_8': 'OTHERS 8',
        'other_9': 'OTHERS 9',
        'other_10': 'OTHERS 10',
      },
      'SINCRONIZACION':{
        'SINCRONIZANDO':'Synchronizing with counting portal, please wait...',
        'SUCCESS':'Synchronization completed correctly'
      }
    },
  }
};
